module.exports = __webpack_public_path__ + "img/paperclip-2.9f479df3.svg";